export default "__VITE_ASSET__DDMB6w8I__"